/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillSyncEntitiesDisplayDate} from '../api'

export const useMutationBackfillSyncEntitiesDisplayDate = createReactQueryMutationHook('backfillSyncEntitiesDisplayDate', backfillSyncEntitiesDisplayDate)
